import { FC, ReactNode, useCallback, useMemo, useReducer, useRef } from "react";
import { createReferentialSyncActions, createReferentialAsyncActions } from "./actions";
import { ReferentialContext } from "./ReferentialContext";
import { initialState, referentialReducer } from "./reducer";

const ReferentialProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(referentialReducer, initialState)

  const stateRef = useRef(state)
  stateRef.current = state
  const getState = useCallback(() => stateRef.current, [])

  const syncActions = useMemo(() => createReferentialSyncActions(dispatch), [])
  const asyncActions = useMemo(() => createReferentialAsyncActions(syncActions, getState), [syncActions, getState])

  const value = useMemo(() => ({
    state,
    dispatch,
    ...syncActions,
    ...asyncActions
  }), [state, dispatch, syncActions, asyncActions])

  return <ReferentialContext.Provider value={value}>
    {children}
  </ReferentialContext.Provider>
}

export default ReferentialProvider
